import { ChangeEvent, Dispatch, KeyboardEvent } from 'react';
import { ESC, DOWN, UP, TAB, ENTER } from 'lib/keyCodes';
import {
  navedDown,
  navedUp,
  escaped,
  inputChanged,
  clickedOut,
} from 'redux-implementations/textSearch';
import { TextSearchState } from 'types/State';

export const handleChange = (
  e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  dispatch: Dispatch<any>
): void => {
  dispatch(inputChanged(e.target.value));
};

export const handleKeyDown = (
  e: KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>,
  state: TextSearchState,
  dispatch: Dispatch<any>,
  callback?: () => void
): void => {
  // arrow up/down button should select next/previous list element
  if (e.keyCode === UP) {
    e.preventDefault();
    dispatch(navedUp);
  } else if (e.keyCode === DOWN) {
    e.preventDefault();
    dispatch(navedDown);

    // enter key pressed
  } else if (e.keyCode === ENTER) {
    e.preventDefault();
    if (typeof state.cursor === 'number') {
      dispatch(inputChanged(state.list[state.cursor].displayName));
      dispatch(clickedOut);
      callback?.();
    }
    // escape key pressed
  } else if (e.keyCode === ESC || (state.dropDownOpen && e.keyCode === TAB)) {
    e.preventDefault();
    dispatch(escaped);
  }
};

// when a user is focused on the mobile input, and scrolls off,
// it blurs and hides the keyboard
export const blurInput = (): void => {
  // react ref will not work
  const input = document.querySelector('input');
  if (input) {
    input.blur();
  }
};
